// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2M2Nf","paramInput":"JobSimulator_paramInput__xMpEZ","input":"JobSimulator_input__3OJFl"};